import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "AuthorPro";

export const ROUTE_TITLES: Record<string, string> = {
  "/": "AuthorPro | Write, Review and Extend Your Book",
  "/write-your-book": `Write Your Book | ${SITE}`,
  "/first-draft": `Manuscript Review | ${SITE}`,
  "/extend": `Extend Your Book | ${SITE}`,
  "/authority-engine": `Extend Your Book | ${SITE}`,
  "/publishers": `For Publishers | ${SITE}`,
  "/events": `Events & Webinars | ${SITE}`,
  "/author-promotion": `Author Promotion | ${SITE}`,
  "/demo": `See It in Action | ${SITE}`,
  "/pricing": `Pricing | ${SITE}`,
  "/qualify": `Is AuthorPro Right for You? | ${SITE}`,
  "/sign-in": `Sign In | ${SITE}`,
  "/privacy-policy": `Privacy Policy | ${SITE}`,
  "/terms-of-service": `Terms of Service | ${SITE}`,
  "/cookie-policy": `Cookie Policy | ${SITE}`,
};

export const titleForPath = (pathname: string) =>
  ROUTE_TITLES[pathname.replace(/\/+$/, "") || "/"] ?? `Page Not Found | ${SITE}`;

/** Sets a distinct browser tab title for each page. */
const RouteTitle = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = titleForPath(pathname);
  }, [pathname]);
  return null;
};

export default RouteTitle;
